import { m, MotionValue } from 'framer-motion';
import { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

export type SheetFrame = {
  y: MotionValue<number>;
  /** 시트가 다 올라왔을 때의 윗변 위치 */
  top: number;
  left: number;
  right: number;
  zIndex?: number;
  mountTo: HTMLElement;
};

export const SheetFrameContext = createContext<SheetFrame | null>(null);

/**
 * 시트 윗변 바깥에 붙는 요소. 시트는 스크롤 컨테이너라 안쪽에서 위로 빼면 잘리므로
 * DragBar 처럼 시트 밖에 그리고 y 를 따라 움직인다.
 */
const AboveSheet = ({ gap = 10, children }: { gap?: number; children: React.ReactNode }) => {
  const frame = useContext(SheetFrameContext);
  if (!frame) return null;

  const isRTL = BResource.isRTL();
  return createPortal(
    <m.div
      data-component="AboveSheet"
      className="fixed"
      style={{
        // transform 은 y 가 쓰므로 윗변 기준 배치는 bottom 으로 한다
        y: frame.y,
        bottom: window.innerHeight - frame.top + gap,
        left: isRTL ? undefined : frame.left + 16,
        right: isRTL ? frame.right + 16 : undefined,
        zIndex: frame.zIndex ?? 102,
      }}
    >
      {children}
    </m.div>,
    frame.mountTo
  );
};

export default AboveSheet;
